import React from 'react';
import {
  BrowserRouter,
  Redirect,
  Route,
  Switch,
  useLocation,
} from 'react-router-dom';
import { App } from './containers/App/App';
import { asyncNamedComponent } from './helpers/AsyncFunc';
import Firebase from './helpers/firebase';
import { getCompany } from './helpers/utility';

const RestrictedRoute = ({ component: Component, ...rest }) => {
  const location = useLocation();
  const user = Firebase.user();
  const company = getCompany();
  console.log('Router firebase', user);
  console.log('Router company', company);
  return (
    <Route
      {...rest}
      render={(props) =>
        user && company ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/companyselect',
              state: { location },
            }}
          />
        )
      }
    />
  );
};

const CompanyRoute = ({ component: Component, ...rest }) => {
  const location = useLocation();
  const user = Firebase.user();
  console.log('company user check', user);
  return (
    <Route
      exact
      path={'/companyselect'}
      render={(props) =>
        user ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/signin',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

/** Signed in, no company needed (the admin panel); the page checks anything more. */
const SignedInRoute = ({ component: Component, ...rest }) => {
  const location = useLocation();
  return (
    <Route
      {...rest}
      render={(props) =>
        Firebase.user() ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: '/signin', state: { from: location } }} />
        )
      }
    />
  );
};

const PublicRoutes = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route
          exact
          path={'/'}
          component={asyncNamedComponent(async () => {
            console.log('sign in component router');
            const { SignIn } = await import('./containers/Page/signin');
            return SignIn;
          })}
        />
        <Route
          exact
          path={'/404'}
          component={asyncNamedComponent(async () => {
            const { Page404 } = await import('./containers/Page/404');
            return Page404;
          })}
        />
        <Route
          exact
          path={'/500'}
          component={asyncNamedComponent(async () => {
            const { Page500 } = await import('./containers/Page/500');
            return Page500;
          })}
        />
        <Route
          exact
          path={'/signin'}
          component={asyncNamedComponent(async () => {
            const { SignIn } = await import('./containers/Page/signin');
            return SignIn;
          })}
        />
        <Route
          exact
          path={'/signup'}
          component={asyncNamedComponent(async () => {
            const { SignUp } = await import('./containers/Page/signup');
            return SignUp;
          })}
        />
        <Route
          exact
          path={'/forgotpassword'}
          component={asyncNamedComponent(async () => {
            const { ForgotPassword } = await import(
              './containers/Page/forgotPassword'
            );
            return ForgotPassword;
          })}
        />
        <Route
          exact
          path={'/resetpassword'}
          component={asyncNamedComponent(async () => {
            const { ResetPassword } = await import(
              './containers/Page/resetPassword'
            );
            return ResetPassword;
          })}
        />
        <Route
          exact
          path={'/connect/mcp'}
          component={asyncNamedComponent(async () => {
            const { ConnectMcp } = await import('./containers/Page/connectMcp');
            return ConnectMcp;
          })}
        />
        <CompanyRoute
          exact
          path={'/companyselect'}
          component={asyncNamedComponent(async () => {
            const { CompanySelect } = await import(
              './containers/Prodo/companySelect'
            );
            return CompanySelect;
          })}
        />
        <Route
          exact
          path={'/portal/:shortName/order/:token'}
          component={asyncNamedComponent(async () => {
            const { CustomerPortal } = await import(
              './containers/CustomerPortal'
            );
            return CustomerPortal;
          })}
        />
        <Route
          exact
          path={'/portal/:shortName/order/:token/paid'}
          component={asyncNamedComponent(async () => {
            const { PaidConfirmation } = await import(
              './containers/CustomerPortal/PaidConfirmation'
            );
            return PaidConfirmation;
          })}
        />
        <Route
          exact
          path={'/portal/:shortName/draft/:token'}
          component={asyncNamedComponent(async () => {
            const { DraftPortal } = await import(
              './containers/CustomerPortal/DraftPortal'
            );
            return DraftPortal;
          })}
        />
        <SignedInRoute
          path={'/admin'}
          component={asyncNamedComponent(async () => {
            const { AdminApp } = await import('./containers/Admin');
            return AdminApp;
          })}
        />
        <RestrictedRoute path="/dashboard" component={App} />
      </Switch>
    </BrowserRouter>
  );
};

export { PublicRoutes };
